<template>
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :heigth="size"
  >
    <!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->
    <path d="M0,0.003h24v24h-24Z" fill="none" />
    <path
      fill="currentColor"
      d="M20,11h-16c-1.104,0 -2,-0.897 -2,-2v-5c0,-1.103 0.896,-2 2,-2h16c1.104,0 2,0.897 2,2v5c0,1.103 -0.896,2 -2,2Zm-16,-7v5h15.997l0.003,-5h-16Z"
    />
    <path
      d="M20,22h-16c-1.104,0 -2,-0.897 -2,-2v-5c0,-1.103 0.896,-2 2,-2h16c1.104,0 2,0.897 2,2v5c0,1.103 -0.896,2 -2,2Zm-16,-7v5h15.997l0.003,-5h-16Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
'use strict'

import mixinIcon from '../mixinIcon'

export default {
  name: 'cursorMoveVertical',
  mixins: [mixinIcon]
}
</script>
